import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { BlogCard } from "./BlogCard";

interface RelatedPostsProps {
  currentPostId: string;
  category: string;
}

export const RelatedPosts = ({ currentPostId, category }: RelatedPostsProps) => {
  const { data: posts } = useQuery({
    queryKey: ["related-posts", category, currentPostId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("blog_posts")
        .select("*")
        .eq("is_published", true)
        .eq("category", category)
        .neq("id", currentPostId)
        .order("published_date", { ascending: false })
        .limit(3);

      if (error) throw error;
      return data;
    },
  });

  if (!posts || posts.length === 0) return null;

  return (
    <section className="mt-16">
      <h2 className="text-3xl font-bold mb-8">Related Articles</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {posts.map((post) => (
          <BlogCard
            key={post.id}
            id={post.id}
            title={post.title}
            slug={post.slug}
            excerpt={post.excerpt}
            featuredImage={post.featured_image || undefined}
            publishedDate={post.published_date}
            category={post.category}
          />
        ))}
      </div>
    </section>
  );
};
